module.exports = __webpack_public_path__ + "static/media/DooClearingColor.9b0fd992.svg";